module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/image-3-73b24d970fe0e1c694b190f8dd3da3b5.png";